import getRangeItemsIds from './get-range-items-ids';
import applySelectionToItems from './apply-selection-to-items';

const handleSingleSelection = (clickedId, items) =>
  items.map((item) => ({
    ...item,
    isSelected: item.id === clickedId ? !item.isSelected : false,
  }));

const handleMultipleSelection = (clickedId, items) => applySelectionToItems(items, [clickedId]);

const handleRangeSelection = (
  clickedId,
  items,
  lastClickedItemId,
  previousRangeSelectedItemIds
) => {
  const itemsUnshifted = applySelectionToItems(items, previousRangeSelectedItemIds, false);
  const rangeSelectedItemIds = getRangeItemsIds(items, lastClickedItemId, clickedId);

  return {
    updatedItems: applySelectionToItems(itemsUnshifted, rangeSelectedItemIds, true),
    rangeSelectedItemIds,
  };
};

export { handleSingleSelection, handleMultipleSelection, handleRangeSelection };
